import axios from "axios";
import toast from "react-hot-toast";
import { getUser, removeCookie } from "../Utils";
import { LOGIN } from "../routes";
import { MESSAGES } from "../Constants/Strings";

const client = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Response interceptor to handle errors and responses
client.interceptors.response.use(
  (response) => {
    return {
      data: response.data,
      status: response.status,
      error: null,
    };
  },
  (error) => {
    if (error.response?.status === 401) {
      removeCookie("user");
      toast.error(MESSAGES.SESSION_TIMEOUT);
      setTimeout(() => {
        window.location.href = LOGIN;
      }, 1500);
    }
    return {
      data: null,
      status: error.response.status,
      error: error.response.data,
    };
  }
);

// Request interceptor to handle requests
client.interceptors.request.use(
  async (config) => {
    const user = await getUser();
    if (user?.token) {
      config.headers.Authorization = `token ${user.token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default client;